/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-return-assign */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-unused-expressions */
/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable no-unused-vars */
import React, {
  useState, useRef, useEffect, useLayoutEffect, useMemo,
} from 'react';
import ActionButton from 'components/Common/ActionButton';
import SideBar from 'components/pages/Marketing/Assets/SideBar';
import FloatBullets from 'components/pages/Marketing/Assets/FloatBullets';
import LoginNavButtons from 'components/pages/Marketing/Assets/LoginNavButtons';
import Container from 'components/pages/Marketing/Assets/Container';
import { useHistory } from 'react-router-dom';
import StrictContainer from 'components/pages/Marketing/Assets/StrictContainer';
import {
  robot,
  bgImgOne,
  bgImgTwo,
  bgImgThree,
  bgImgFour,
  collaboration,
  couponLong,
  shopeeLogo,
  PhoneIcon2,
  MailIcon2,
  LINEicon2,
  HHGBrandLogo2,
  HGGFullLogo,
  EffectImg,
  industryOne,
  industryTwo,
  industryThree,
  industryFour,
  industryFive,
  industrySix,
  industrySeven,
  industryEight,
  FacebookIcon2,
  GoogleIcon2,
  PChomeIcon2,
  ShopeeIcon2,
} from 'assets/exports/imageExport';
import {
  VideoStep1,
  VideoStep2,
  VideoStep3,
  VideoStep4,
} from 'assets/exports/videoExport';
import classNames from 'classnames';
import Styles from './index.module.css';

function MarketingHome() {
  const history = useHistory();
  // Step block state
  const [slideVideos] = useState([VideoStep1, VideoStep2, VideoStep3, VideoStep4]);
  const [stepFilter] = useState([
    <span>選擇廣告媒體、<br />調整受眾</span>,
    <span>上傳廣告素材</span>,
    <span>完成儲值</span>,
    <span>設定廣告走期、<br />廣告等待上線！</span>,
  ]);
  const [activeId, setActiveId] = useState(1);

  // Category block state
  const exceptionIndex = [0, 3, 5, 10];
  const [activeIndustryId, setActiveIndustryId] = useState(0);
  const counter = useRef(0);
  const [industries] = useState([
    {
      name: '寵物用品',
      stata: [{ title: '廣告業績', info: '(當週)+320%' }, { title: '其他', info: '客單價提升157%' }],
      description: '大檔期間運用【PowerAI智能廣告管家】投廣，快速完成廣告設定，因應密集檔期自由調整廣告，創造三倍業績成長!',
      img: industryFive,
    },
    {
      name: '家電',
      stata: [{ title: '點擊率', info: '+126%' }, { title: '轉換率', info: '+127%' }, { title: 'ROAS', info: '+200%' }],
      description: '活動大檔前一週運用【PowerAI智能廣告管家】曝光新品，自動篩選最佳受眾組合投廣，吸引更多消費者加入購物車。活動當日拉高預算，廣告投資報酬率提升2倍!',
      img: industrySix,
    },
    {
      name: '美食伴手禮',
      stata: [{ title: '轉換率', info: '+320%' }, { title: 'ROAS', info: '+280%' }, { title: '其他', info: '轉換訂單成本降低74%' }],
      description: '運用【PowerAI智能廣告管家】自主設定廣告內容，活動前一日開啟廣告，提前累積有興趣購買的客戶，用更少的成本獲得更多轉換訂單!',
      img: industryOne,
    },
    {
      name: '男性配件',
      stata: [{ title: '點擊率', info: '+190%' }, { title: 'ROAS', info: '+260%' }, { title: '其他', info: '轉換訂單成本降低80%' }],
      description: '使用【 PowerAI智能廣告管家】，日常輕鬆設定Google PMAX廣告，系統利用機器學習製作不同的素材組合，顯示最相關的廣告，更有效提升廣告點擊率和進站流量!',
      img: industryTwo,
    },
    {
      name: '生活娛樂',
      stata: [{ title: '廣告業績', info: '+102%' }, { title: 'ROAS', info: '(新客)+130%' }, { title: '其他', info: '新客點擊成本降低25%' }],
      description: '使用【PowerAI智能廣告管家】，輕鬆設定Facebook商品輪播廣告，系統智慧篩選消費者感興趣的商品投放，拉高新客點擊廣告意願，提升1.2倍的新客廣告業積!',
      img: industryThree,
    },
    {
      name: '母嬰用品',
      stata: [{ title: '點擊率', info: '+300%' }, { title: '廣告業績', info: '+500%' }, { title: '其他', info: '轉換訂單成本降低53%' }],
      description: '透過【PowerAI智能廣告管家】的視覺化成效報告，賣家即時掌握調整方向進行廣告優化，有效提升三倍的點閱率，收割五倍的廣告業績!',
      img: industryFour,
    },
    {
      name: '女性服飾',
      stata: [{ title: '轉換率', info: '+900%' }, { title: 'ROAS', info: '+300%' }, { title: '其他', info: '轉換訂單成本降低80%' }],
      description: '新品牌運用【PowerAI智能廣告管家】進行日常廣告曝光，智能優化鎖定新客投放累積流量，活動期間加大預算投放，轉換率大幅提升!',
      img: industrySeven,
    },
    {
      name: '3C產品/周邊',
      stata: [{ title: '轉換率', info: '+200%' }, { title: '廣告業績', info: '+1000%' }, { title: 'ROAS', info: '+440%' }],
      description: '運用【PowerAI智能廣告管家】，輕鬆設定Facebook成效型廣告格式，運用「精選集廣告」吸引新客進店，運用「輪播廣告」增加再行銷客群下單，廣告業績提升10倍!',
      img: industryEight,
    },
  ]);
  useEffect(() => {
    counter.current = 0;
    return () => {
      counter.current = 0;
    };
  });
  const squareRefs = industries.map(() => useRef(null));

  const transparentNode = () => (
    <div className={classNames(Styles.categories__stataGridElem_wrapped,
      Styles.categories__stataGridElem_wrapped_transparent)}
    >
      <div className={classNames(Styles.categories__stataGridElem,
        Styles.categories__stataGridElem_transparent)}
      />
    </div>
  );
  const interactiveNode = (industry, id, arr) => {
    if (counter.current < arr.length - 1) counter.current += 1;
    else counter.current = 0;
    return (
      <div
        key={industry?.name}
        ref={squareRefs[id]}
        onClick={() => { setActiveIndustryId(+squareRefs[id]?.current.id); }}
        id={id}
        data-cat={industry?.name}
        className={Styles.categories__stataGridElem_wrapped}
      >
        <div className={Styles.categories__stataGridElem}>
          <img className={Styles.categories__stataGridImg} src={industry?.img} alt={industry?.name} />
        </div>
      </div>
    );
  };

  // Anchors refs
  const sectionOneRef = useRef();
  const sectionTwoRef = useRef();
  const sectionThreeRef = useRef();
  const sectionFourRef = useRef();
  const sectionFiveRef = useRef();
  const sectionSixRef = useRef();
  const sectionSevenRef = useRef();
  const sectionEightRef = useRef();
  const sectionNineRef = useRef();

  const sections = [
    {
      headerRef: sectionOneRef,
      id: 'sectionOne',
    },
    {
      headerRef: sectionTwoRef,
      id: 'sectionTwo',
    },
    {
      headerRef: sectionThreeRef,
      id: 'sectionThree',
    },
    {
      headerRef: sectionFourRef,
      id: 'sectionFour',
    },
    {
      headerRef: sectionFiveRef,
      id: 'sectionFive',
    },
    {
      headerRef: sectionSixRef,
      id: 'sectionSix',
    },
    {
      headerRef: sectionSevenRef,
      id: 'sectionSeven',
    },
    {
      headerRef: sectionEightRef,
      id: 'sectionEight',
    },
    {
      headerRef: sectionNineRef,
      id: 'sectionNine',
    },
  ];

  return (
    <>
      <Container>
        <StrictContainer>
          <SideBar />
          <LoginNavButtons><FloatBullets sections={sections} /></LoginNavButtons>
        </StrictContainer>

        {/* <StrictContainer className={Styles.couponBlock}>
          <div className={Styles.investmentSystem} ref={sectionOneRef} id="sectionZero">
            <div className={Styles.coupon__image_wrapped}>
              <img
                className={Styles.coupon__image}
                src={couponLong}
                alt="coupon"
                onClick={() => { window.open('https://www.hhgalaxy.com.tw/qa/95#354', '_blank'); }}
              />
            </div>
          </div>
        </StrictContainer> */}

        <StrictContainer>
          <div className={Styles.investmentSystem} ref={sectionOneRef} id="sectionOne">
            <div className={Styles.investmentSystemTitle_wrapped}>
              <h1 className={classNames(Styles.title, Styles.investmentSystemTitle)}>
                PowerAI智能廣告管家
                <br />
                你的廣告最佳幫手!
              </h1>
            </div>
            <div className={Styles.investmentSystem__content}>
              <p className={Styles.investmentSystem__tags}>24H系統在線等候 X 超簡易操作 X 即時成效報表</p>
              <div className={Styles.investmentSystem__buttons_wrapped}>
                <ActionButton onClick={() => history.push('/Register')}>開始設定廣告</ActionButton>
                <ActionButton onClick={() => history.push('/Offer')}>了解成效型廣告</ActionButton>
              </div>
              <p className={Styles.investmentSystem__text}>
                設定廣告，可以更方便、全面、即時、智慧！<br />
                讓【PowerAI智能廣告管家】包辦您廣告的大小事！<br />
                ✔ 方便：管家 24 小時在線等候，隨時都能上傳廣告需求<br />
                ✔ 全面：支援Facebook、Google多種格式廣告投放，熱門版位一鍵投放！<br />
                ✔ 即時：提供【即時線上全通路報表】和客製化建議，隨時掌握廣告狀況<br />
                ✔ 智慧：智能更新電商高價值受眾，鎖定潛在客群投放，提高下單率！
              </p>
            </div>
            <div className={Styles.investmentSystem__image_wrapped}>
              <img className={Styles.investmentSystem__image} src={robot} alt="robot" />
            </div>
          </div>
        </StrictContainer>

        <StrictContainer>
          <div className={Styles.advantage} ref={sectionTwoRef} id="sectionTwo">
            <div className={Styles.advantageTitle_wrapped}>
              <h1 className={classNames(Styles.title, Styles.advantageTitle)}>
                【PowerAI智能廣告管家 】四大優勢
                <span className={Styles.advantageTitleOverlay} />
              </h1>
            </div>
            <div className={Styles.advantage__content_wrapped}>
              <div className={Styles.advantage__content}>
                <h4 className={Styles.advantage__contentTitle}>短短五分鐘，輕鬆完成設定</h4>
                <div className={Styles.advantage__contentOrnament} />
                <p className={Styles.advantage__contentSubtitle}>
                  超簡易的系統流程，您只需要準備好廣告文案和素材，就能快速讓廣告曝光！
                </p>
                <img src={bgImgOne} alt="Static background" className={Styles.advantage__contentBgi} />
              </div>
              <div className={Styles.advantage__content}>
                <h4 className={Styles.advantage__contentTitle}>投放全版位，電商官網都行</h4>
                <div className={Styles.advantage__contentOrnament} />
                <p className={Styles.advantage__contentSubtitle}>
                  3大電商 x 自架官網 x 多重媒體渠道，支援各通路串接，實現一站式投放廣告！
                </p>
                <img src={bgImgTwo} alt="Static background" className={Styles.advantage__contentBgi} />
              </div>
            </div>
            <div className={Styles.advantage__content_wrapped}>
              <div className={Styles.advantage__content}>
                <h4 className={Styles.advantage__contentTitle}>平台受眾包，精準觸及客群</h4>
                <div className={Styles.advantage__contentOrnament} />
                <p className={Styles.advantage__contentSubtitle}>
                  支援 Momo、蝦皮、PChome站內受眾自動更新，讓您的廣告鎖定平台高度意願轉換客群，提升轉換率
                </p>
                <img src={bgImgThree} alt="Static background" className={Styles.advantage__contentBgi} />
              </div>
              <div className={Styles.advantage__content}>
                <h4 className={Styles.advantage__contentTitle}>成效一把抓，報表即時在線</h4>
                <div className={Styles.advantage__contentOrnament} />
                <p className={Styles.advantage__contentSubtitle}>
                  24H數據更新零時差！視覺化報表即時反映廣告成效，讓您隨時掌握廣告趨勢！
                </p>
                <img src={bgImgFour} alt="Static background" className={Styles.advantage__contentBgi} />
              </div>
            </div>
          </div>
        </StrictContainer>

        <StrictContainer>
          <div className={Styles.effect} ref={sectionThreeRef} id="sectionThree">
            <div className={Styles.effect__text_wrapped}>
              <div className={Styles.effectTitle_wrapped}>
                <h1 className={classNames(Styles.effectTitle, Styles.title)}>成效型廣告</h1>
              </div>
              <p className={Styles.effect__text}>
                以轉換極大化為目標的廣告利器
                <br />
                成效型廣告將投資的每一塊錢放大
              </p>
            </div>
            <div className={Styles.effect__img_wrapped}>
              <img src={EffectImg} alt="Ads on smartphone" className={Styles.effect__img} />
            </div>
            <p className={classNames(Styles.effect__text, Styles.effect__text_mobile)}>
              以轉換極大化為目標的廣告利器
              <br />
              成效型廣告將投資的每一塊錢放大
            </p>
          </div>
        </StrictContainer>

        <StrictContainer>
          <div className={Styles.collaboration} ref={sectionFourRef} id="sectionFour">
            <div className={Styles.collaborationTitle_wrapped}>
              <h1 className={classNames(Styles.collaborationTitle, Styles.title)}>
                最佳代理商做您的最強神隊友
                <span className={Styles.collaborationTitleOverlay} />
              </h1>
            </div>
            <div className={Styles.collaboration__img_wrapped}>
              <img src={collaboration} alt="Collaboration illustration" className={Styles.collaboration__img} />
            </div>
            <div className={Styles.collaboration__cards}>
              <div className={Styles.collaboration__card}>
                <div className={Styles.collaboration__cardIcon_wrapped}>
                  <img src={FacebookIcon2} alt="Shopee logo" className={Styles.collaboration__cardIcon} />
                </div>
                <span className={Styles.collaboration__cardText}>認證廣告代理商</span>
              </div>
              <div className={Styles.collaboration__card}>
                <div className={Styles.collaboration__cardIcon_wrapped}>
                  <img src={GoogleIcon2} alt="Shopee logo" className={Styles.collaboration__cardIcon} />
                </div>
                <span className={Styles.collaboration__cardText}>成效型廣告合作夥伴</span>
              </div>
              <div className={Styles.collaboration__card}>
                <div className={Styles.collaboration__cardIcon_wrapped}>
                  <img src={ShopeeIcon2} alt="Shopee logo" className={Styles.collaboration__cardIcon} />
                </div>
                <span className={Styles.collaboration__cardText}>官方認證代理商</span>
              </div>
              <div className={Styles.collaboration__card}>
                <div className={Styles.collaboration__cardIcon_wrapped}>
                  <img src={PChomeIcon2} alt="Shopee logo" className={Styles.collaboration__cardIcon} />
                </div>
                <span className={Styles.collaboration__cardText}>成效型廣告合作夥伴</span>
              </div>
            </div>
          </div>
        </StrictContainer>

        <StrictContainer>
          <div className={Styles.score} ref={sectionFiveRef} id="sectionFive">
            <div className={Styles.scoreTitle_wrapped}>
              <h1 className={classNames(Styles.scoreTitle, Styles.title)}>
                媒體投廣成績
                <span className={Styles.scoreTitleOverlay} />
              </h1>
            </div>
            <div className={Styles.score__cards}>
              <div className={Styles.score__card}>
                <h4 className={Styles.score__cardTitle}>300+個</h4>
                <div className={Styles.score__cardOrnament} />
                <p className={Styles.score__cardSubtitle}>
                  知名品牌
                  <br />
                  廣告操作經驗
                </p>
              </div>
              <div className={Styles.score__card}>
                <h4 className={Styles.score__cardTitle}>4億元</h4>
                <div className={Styles.score__cardOrnament} />
                <p className={Styles.score__cardSubtitle}>
                  2021年
                  <br />
                  媒體操作總預算
                </p>
              </div>
              <div className={Styles.score__card}>
                <h4 className={Styles.score__cardTitle}>15,000筆/月</h4>
                <div className={Styles.score__cardOrnament} />
                <p className={Styles.score__cardSubtitle}>
                  成效型廣告
                  <br />
                  轉換訂單
                </p>
              </div>
            </div>
          </div>
        </StrictContainer>

        <StrictContainer>
          <div className={Styles.categories} ref={sectionSixRef} id="sectionSix">
            <div className={Styles.categoriesTitle_wrapped}>
              <h1 className={classNames(Styles.categoriesTitle, Styles.title)}>精選客戶案例</h1>
            </div>
            <ul className={Styles.categories__list}>
              {industries.map((item, index) => (
                <li
                  onClick={() => { setActiveIndustryId(index); }}
                  key={item.name}
                  className={activeIndustryId === index
                    ? classNames(Styles.categories__listItem, Styles.categories__listItemActive)
                    : Styles.categories__listItem}
                >{item.name}
                </li>
              ))}
            </ul>
            <div className={Styles.categories__stata}>
              <div className={Styles.categories__stataGrid}>
                {[...Array(12).keys()].map((item, index) => (exceptionIndex.includes(index)
                  ? transparentNode()
                  : interactiveNode(industries[counter.current], counter.current, industries)))}
              </div>
              <div className={Styles.categories__stataContent}>
                <div className={Styles.categories__stataInfo}>
                  <h4 className={Styles.categories__stataTitle}>{industries[activeIndustryId].name}</h4>
                  <div className={Styles.categories__stataOrnament} />
                  <p className={Styles.categories__stataSubtitle}>{industries[activeIndustryId].description}</p>
                </div>
                <div className={Styles.categories__stataDetails}>
                  {industries[activeIndustryId].stata.map((item) => (
                    <div className={Styles.categories__stataRoas}>
                      <span className={Styles.categories__stataRoasTitle}>{item.title}</span>
                      <span className={classNames(Styles.categories__stataRoasSubtitle,
                        {
                          [Styles.categories__stataRoasSubtitle_small]: item.title === '其他',
                        })}
                      >{item.info}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </StrictContainer>

        <StrictContainer>
          <div className={Styles.addons} ref={sectionSevenRef} id="sectionSeven">
            <div className={Styles.addonsTitle_wrapped}>
              <h1 className={classNames(Styles.addonsTitle, Styles.title)}>
                除此之外，我們能給您更多
                <span className={Styles.addonsTitleOverlay} />
              </h1>
            </div>
            <div className={Styles.addons__cards}>
              <div className={Styles.addons__card}>
                <h4 className={Styles.addons__cardTitle}>視覺化成效</h4>
                <div className={Styles.addons__cardOrnament} />
                <p className={Styles.addons__cardSubtitle}>
                  Data Studio圖表
                  <br />
                  清楚呈現廣告數據
                  <br />
                  讀懂報表沒問題
                </p>
              </div>
              <div className={Styles.addons__card}>
                <h4 className={Styles.addons__cardTitle}>隨時解惑</h4>
                <div className={Styles.addons__cardOrnament} />
                <p className={Styles.addons__cardSubtitle}>
                  利用問答集、官方Line
                  <br />
                  隨時為您解答
                  <br />
                  待線等候
                </p>
              </div>
              <div className={Styles.addons__card}>
                <h4 className={Styles.addons__cardTitle}>加值服務</h4>
                <div className={Styles.addons__cardOrnament} />
                <p className={Styles.addons__cardSubtitle}>
                  素材製作、Banner設計
                  <br />
                  提供各種媒體投放服務
                  <br />
                  滿足您的需求
                </p>
              </div>
            </div>
          </div>
        </StrictContainer>

        <StrictContainer>
          <div className={Styles.steps} ref={sectionEightRef} id="sectionEight">
            <div className={Styles.stepsTitle_wrapped}>
              <h1 className={classNames(Styles.stepsTitle, Styles.title)}>
                簡單四步驟
                <br />
                完成廣告投資設定
              </h1>
            </div>
            <div className={Styles.tabs}>
              {stepFilter.map((str, id) => (
                <button
                  type="button"
                  id={`step${id + 1}`}
                  className={activeId === id + 1
                    ? classNames(Styles.tabs__tab, Styles.tabs__tab_active)
                    : classNames(Styles.tabs__tab)}
                  onClick={() => { setActiveId(id + 1); }}
                >
                  <h4 className={Styles.tabs__tabTitle}>
                    {`Step ${id + 1}`}
                  </h4>
                  <div className={Styles.tabs__tabOrnament} />
                  <p className={Styles.tabs__tabSubtitle}>{str}</p>
                </button>
              ))}
            </div>
            <div className={Styles.info}>
              <div className={Styles.infoSlide}>
                <div className={Styles.infoSlideLaptop}>
                  {slideVideos.map((video, id) => (
                    <video
                      preload
                      playsInline
                      autoPlay
                      muted
                      loop
                      controls
                      alt="操作平台的步驟影片"
                      className={activeId === id + 1
                        ? classNames(Styles.infoSlideVideo, Styles.infoSlideVideo_active)
                        : classNames(Styles.infoSlideVideo)}
                    >
                      Your browser does not support video tag
                      <source src={video} type="video/mp4" />
                    </video>
                  ))}
                  <div className={Styles.infoSlideLaptopBase} />
                </div>
              </div>
            </div>
          </div>
        </StrictContainer>

        <StrictContainer>
          <div className={Styles.prefooter} ref={sectionNineRef} id="sectionNine">
            <div className={Styles.prefooterTitle_wrapped}>
              <h1 className={classNames(Styles.prefooterTitle, Styles.title)}>開始建立您的第一個廣告投資</h1>
            </div>
            <div className={Styles.prefooterButtons_wrapped}>
              <ActionButton onClick={() => history.push('/Calculator')}>試算報酬</ActionButton>
              <ActionButton onClick={() => history.push('/Register')}>開始設定廣告</ActionButton>
            </div>
          </div>
        </StrictContainer>

        <footer className={Styles.footer}>
          <StrictContainer>
            <div className={Styles.footerContent}>
              <div className={Styles.footerLogo_wrapped}>
                <img src={HHGBrandLogo2} alt="Footer logo of Galaxy" />
              </div>
              <div className={Styles.footerIcon_wrapped}>
                <img src={PhoneIcon2} alt="Phone Icon" />
              </div>
              <a href="mailto:contactme@hhgalaxy.com.tw" className={Styles.footerIcon_wrapped}>
                <img src={MailIcon2} alt="Mail Icon" />
              </a>
              <a rel="noreferrer" target="_blank" href="https://liff.line.me/1645278921-kWRPP32q/?accountId=416ksyvl" className={Styles.footerIcon_wrapped}>
                <img src={LINEicon2} alt="Line Icon" />
              </a>
              <div className={Styles.footerLogo_wrapped_mobile}>
                <img src={HGGFullLogo} alt="Footer logo of Galaxy" />
              </div>
            </div>
          </StrictContainer>
        </footer>
      </Container>
    </>
  );
}

export default MarketingHome;
